import React from 'react';
import { createRoot } from 'react-dom/client';
import FitAssistantBikes from './FitAssistantBikes.tsx';
import * as Sentry from '@sentry/react';
import { AppStateProvider } from './BikesAppState.tsx';

const rootElement = document.getElementById('REACT_FitAssistant_new');

if (rootElement) {
  const root = createRoot(rootElement);
  root.render(
    <AppStateProvider>
      <Sentry.ErrorBoundary fallback={<div>An error has occurred</div>}>
        <FitAssistantBikes />
      </Sentry.ErrorBoundary>
    </AppStateProvider>
  );
}
